import { render, staticRenderFns } from "./Photo.vue?vue&type=template&id=18a5cfec&scoped=true"
import script from "./Photo.vue?vue&type=script&lang=js"
export * from "./Photo.vue?vue&type=script&lang=js"
import style0 from "./Photo.vue?vue&type=style&index=0&id=18a5cfec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a5cfec",
  null
  
)

export default component.exports